export const RoutesFlags = {
    'es-SP': '/assets/images/flags/spain.svg',
    'en-UK': '/assets/images/flags/UK.png',
    'es-CO': '/assets/images/flags/es-CO.png',
    'en-US': '/assets/images/flags/en-US.png',
};
